import { jsxs as be, jsx as se } from "react/jsx-runtime";
import { useEffect as U, useContext as ke, createContext as Ze, useState as X, useRef as Ye } from "react";
function Ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var B = {}, ge;
function Fe() {
  if (ge) return B;
  ge = 1, B.match = s, B.parse = d;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, a = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, c = /^(?:(min|max)-)?(.+)/, i = /(em|rem|px|cm|mm|in|pt|pc)?$/, f = /(dpi|dpcm|dppx)?$/;
  function s(l, u) {
    return d(l).some(function(m) {
      var E = m.inverse, $ = m.type === "all" || u.type === m.type;
      if ($ && E || !($ || E))
        return !1;
      var P = m.expressions.every(function(I) {
        var j = I.feature, k = I.modifier, C = I.value, T = u[j];
        if (!T)
          return !1;
        switch (j) {
          case "orientation":
          case "scan":
            return T.toLowerCase() === C.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            C = O(C), T = O(T);
            break;
          case "resolution":
            C = y(C), T = y(T);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            C = p(C), T = p(T);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            C = parseInt(C, 10) || 1, T = parseInt(T, 10) || 0;
            break;
        }
        switch (k) {
          case "min":
            return T >= C;
          case "max":
            return T <= C;
          default:
            return T === C;
        }
      });
      return P && !E || !P && E;
    });
  }
  function d(l) {
    return l.split(",").map(function(u) {
      u = u.trim();
      var m = u.match(e), E = m[1], $ = m[2], P = m[3] || "", I = {};
      return I.inverse = !!E && E.toLowerCase() === "not", I.type = $ ? $.toLowerCase() : "all", P = P.match(/\([^\)]+\)/g) || [], I.expressions = P.map(function(j) {
        var k = j.match(a), C = k[1].toLowerCase().match(c);
        return {
          modifier: C[1],
          feature: C[2],
          value: k[2]
        };
      }), I;
    });
  }
  function p(l) {
    var u = Number(l), m;
    return u || (m = l.match(/^(\d+)\s*\/\s*(\d+)$/), u = m[1] / m[2]), u;
  }
  function y(l) {
    var u = parseFloat(l), m = String(l).match(f)[1];
    switch (m) {
      case "dpcm":
        return u / 2.54;
      case "dppx":
        return u * 96;
      default:
        return u;
    }
  }
  function O(l) {
    var u = parseFloat(l), m = String(l).match(i)[1];
    switch (m) {
      case "em":
        return u * 16;
      case "rem":
        return u * 16;
      case "cm":
        return u * 96 / 2.54;
      case "mm":
        return u * 96 / 2.54 / 10;
      case "in":
        return u * 96;
      case "pt":
        return u * 72;
      case "pc":
        return u * 72 / 12;
      default:
        return u;
    }
  }
  return B;
}
var ce, Le;
function We() {
  if (Le) return ce;
  Le = 1;
  var e = Fe().match, a = typeof window < "u" ? window.matchMedia : null;
  function c(f, s, d) {
    var p = this, y;
    a && !d && (y = a.call(window, f)), y ? (this.matches = y.matches, this.media = y.media, y.addListener(u)) : (this.matches = e(f, s), this.media = f), this.addListener = O, this.removeListener = l, this.dispose = m;
    function O(E) {
      y && y.addListener(E);
    }
    function l(E) {
      y && y.removeListener(E);
    }
    function u(E) {
      p.matches = E.matches, p.media = E.media;
    }
    function m() {
      y && y.removeListener(u);
    }
  }
  function i(f, s, d) {
    return new c(f, s, d);
  }
  return ce = i, ce;
}
var Ue = We();
const Ve = /* @__PURE__ */ Ae(Ue);
var Ne = /[A-Z]/g, ze = /^ms-/, ue = {};
function He(e) {
  return "-" + e.toLowerCase();
}
function Ie(e) {
  if (ue.hasOwnProperty(e))
    return ue[e];
  var a = e.replace(Ne, He);
  return ue[e] = ze.test(a) ? "-" + a : a;
}
function Qe(e, a) {
  if (e === a)
    return !0;
  if (!e || !a)
    return !1;
  const c = Object.keys(e), i = Object.keys(a), f = c.length;
  if (i.length !== f)
    return !1;
  for (let s = 0; s < f; s++) {
    const d = c[s];
    if (e[d] !== a[d] || !Object.prototype.hasOwnProperty.call(a, d))
      return !1;
  }
  return !0;
}
var K = { exports: {} }, J = { exports: {} }, _ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ee;
function Be() {
  if (Ee) return _;
  Ee = 1;
  var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, c = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, f = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, E = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, k = e ? Symbol.for("react.scope") : 60119;
  function C(n) {
    if (typeof n == "object" && n !== null) {
      var F = n.$$typeof;
      switch (F) {
        case a:
          switch (n = n.type, n) {
            case y:
            case O:
            case i:
            case s:
            case f:
            case u:
              return n;
            default:
              switch (n = n && n.$$typeof, n) {
                case p:
                case l:
                case $:
                case E:
                case d:
                  return n;
                default:
                  return F;
              }
          }
        case c:
          return F;
      }
    }
  }
  function T(n) {
    return C(n) === O;
  }
  return _.AsyncMode = y, _.ConcurrentMode = O, _.ContextConsumer = p, _.ContextProvider = d, _.Element = a, _.ForwardRef = l, _.Fragment = i, _.Lazy = $, _.Memo = E, _.Portal = c, _.Profiler = s, _.StrictMode = f, _.Suspense = u, _.isAsyncMode = function(n) {
    return T(n) || C(n) === y;
  }, _.isConcurrentMode = T, _.isContextConsumer = function(n) {
    return C(n) === p;
  }, _.isContextProvider = function(n) {
    return C(n) === d;
  }, _.isElement = function(n) {
    return typeof n == "object" && n !== null && n.$$typeof === a;
  }, _.isForwardRef = function(n) {
    return C(n) === l;
  }, _.isFragment = function(n) {
    return C(n) === i;
  }, _.isLazy = function(n) {
    return C(n) === $;
  }, _.isMemo = function(n) {
    return C(n) === E;
  }, _.isPortal = function(n) {
    return C(n) === c;
  }, _.isProfiler = function(n) {
    return C(n) === s;
  }, _.isStrictMode = function(n) {
    return C(n) === f;
  }, _.isSuspense = function(n) {
    return C(n) === u;
  }, _.isValidElementType = function(n) {
    return typeof n == "string" || typeof n == "function" || n === i || n === O || n === s || n === f || n === u || n === m || typeof n == "object" && n !== null && (n.$$typeof === $ || n.$$typeof === E || n.$$typeof === d || n.$$typeof === p || n.$$typeof === l || n.$$typeof === I || n.$$typeof === j || n.$$typeof === k || n.$$typeof === P);
  }, _.typeOf = C, _;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ce;
function Ke() {
  return Ce || (Ce = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, c = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, f = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, y = e ? Symbol.for("react.async_mode") : 60111, O = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, E = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, j = e ? Symbol.for("react.responder") : 60118, k = e ? Symbol.for("react.scope") : 60119;
    function C(t) {
      return typeof t == "string" || typeof t == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      t === i || t === O || t === s || t === f || t === u || t === m || typeof t == "object" && t !== null && (t.$$typeof === $ || t.$$typeof === E || t.$$typeof === d || t.$$typeof === p || t.$$typeof === l || t.$$typeof === I || t.$$typeof === j || t.$$typeof === k || t.$$typeof === P);
    }
    function T(t) {
      if (typeof t == "object" && t !== null) {
        var Y = t.$$typeof;
        switch (Y) {
          case a:
            var Q = t.type;
            switch (Q) {
              case y:
              case O:
              case i:
              case s:
              case f:
              case u:
                return Q;
              default:
                var he = Q && Q.$$typeof;
                switch (he) {
                  case p:
                  case l:
                  case $:
                  case E:
                  case d:
                    return he;
                  default:
                    return Y;
                }
            }
          case c:
            return Y;
        }
      }
    }
    var n = y, F = O, G = p, ee = d, re = a, te = l, z = i, ne = $, oe = E, V = c, ae = s, Z = f, W = u, H = !1;
    function ie(t) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(t) || T(t) === y;
    }
    function r(t) {
      return T(t) === O;
    }
    function o(t) {
      return T(t) === p;
    }
    function L(t) {
      return T(t) === d;
    }
    function b(t) {
      return typeof t == "object" && t !== null && t.$$typeof === a;
    }
    function v(t) {
      return T(t) === l;
    }
    function w(t) {
      return T(t) === i;
    }
    function h(t) {
      return T(t) === $;
    }
    function g(t) {
      return T(t) === E;
    }
    function x(t) {
      return T(t) === c;
    }
    function A(t) {
      return T(t) === s;
    }
    function R(t) {
      return T(t) === f;
    }
    function D(t) {
      return T(t) === u;
    }
    M.AsyncMode = n, M.ConcurrentMode = F, M.ContextConsumer = G, M.ContextProvider = ee, M.Element = re, M.ForwardRef = te, M.Fragment = z, M.Lazy = ne, M.Memo = oe, M.Portal = V, M.Profiler = ae, M.StrictMode = Z, M.Suspense = W, M.isAsyncMode = ie, M.isConcurrentMode = r, M.isContextConsumer = o, M.isContextProvider = L, M.isElement = b, M.isForwardRef = v, M.isFragment = w, M.isLazy = h, M.isMemo = g, M.isPortal = x, M.isProfiler = A, M.isStrictMode = R, M.isSuspense = D, M.isValidElementType = C, M.typeOf = T;
  }()), M;
}
var Te;
function $e() {
  return Te || (Te = 1, process.env.NODE_ENV === "production" ? J.exports = Be() : J.exports = Ke()), J.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fe, we;
function Je() {
  if (we) return fe;
  we = 1;
  var e = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function f() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var d = {}, p = 0; p < 10; p++)
        d["_" + String.fromCharCode(p)] = p;
      var y = Object.getOwnPropertyNames(d).map(function(l) {
        return d[l];
      });
      if (y.join("") !== "0123456789")
        return !1;
      var O = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        O[l] = l;
      }), Object.keys(Object.assign({}, O)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fe = f() ? Object.assign : function(s, d) {
    for (var p, y = i(s), O, l = 1; l < arguments.length; l++) {
      p = Object(arguments[l]);
      for (var u in p)
        a.call(p, u) && (y[u] = p[u]);
      if (e) {
        O = e(p);
        for (var m = 0; m < O.length; m++)
          c.call(p, O[m]) && (y[O[m]] = p[O[m]]);
      }
    }
    return y;
  }, fe;
}
var le, xe;
function me() {
  if (xe) return le;
  xe = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return le = e, le;
}
var de, Re;
function je() {
  return Re || (Re = 1, de = Function.call.bind(Object.prototype.hasOwnProperty)), de;
}
var pe, Oe;
function Xe() {
  if (Oe) return pe;
  Oe = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = /* @__PURE__ */ me(), c = {}, i = /* @__PURE__ */ je();
    e = function(s) {
      var d = "Warning: " + s;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function f(s, d, p, y, O) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in s)
        if (i(s, l)) {
          var u;
          try {
            if (typeof s[l] != "function") {
              var m = Error(
                (y || "React class") + ": " + p + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            u = s[l](d, l, y, p, null, a);
          } catch ($) {
            u = $;
          }
          if (u && !(u instanceof Error) && e(
            (y || "React class") + ": type specification of " + p + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in c)) {
            c[u.message] = !0;
            var E = O ? O() : "";
            e(
              "Failed " + p + " type: " + u.message + (E ?? "")
            );
          }
        }
    }
  }
  return f.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (c = {});
  }, pe = f, pe;
}
var ve, Se;
function Ge() {
  if (Se) return ve;
  Se = 1;
  var e = $e(), a = Je(), c = /* @__PURE__ */ me(), i = /* @__PURE__ */ je(), f = /* @__PURE__ */ Xe(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(p) {
    var y = "Warning: " + p;
    typeof console < "u" && console.error(y);
    try {
      throw new Error(y);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return ve = function(p, y) {
    var O = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function u(r) {
      var o = r && (O && r[O] || r[l]);
      if (typeof o == "function")
        return o;
    }
    var m = "<<anonymous>>", E = {
      array: j("array"),
      bigint: j("bigint"),
      bool: j("boolean"),
      func: j("function"),
      number: j("number"),
      object: j("object"),
      string: j("string"),
      symbol: j("symbol"),
      any: k(),
      arrayOf: C,
      element: T(),
      elementType: n(),
      instanceOf: F,
      node: te(),
      objectOf: ee,
      oneOf: G,
      oneOfType: re,
      shape: ne,
      exact: oe
    };
    function $(r, o) {
      return r === o ? r !== 0 || 1 / r === 1 / o : r !== r && o !== o;
    }
    function P(r, o) {
      this.message = r, this.data = o && typeof o == "object" ? o : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function I(r) {
      if (process.env.NODE_ENV !== "production")
        var o = {}, L = 0;
      function b(w, h, g, x, A, R, D) {
        if (x = x || m, R = R || g, D !== c) {
          if (y) {
            var t = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw t.name = "Invariant Violation", t;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Y = x + ":" + g;
            !o[Y] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + R + "` prop on `" + x + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), o[Y] = !0, L++);
          }
        }
        return h[g] == null ? w ? h[g] === null ? new P("The " + A + " `" + R + "` is marked as required " + ("in `" + x + "`, but its value is `null`.")) : new P("The " + A + " `" + R + "` is marked as required in " + ("`" + x + "`, but its value is `undefined`.")) : null : r(h, g, x, A, R);
      }
      var v = b.bind(null, !1);
      return v.isRequired = b.bind(null, !0), v;
    }
    function j(r) {
      function o(L, b, v, w, h, g) {
        var x = L[b], A = Z(x);
        if (A !== r) {
          var R = W(x);
          return new P(
            "Invalid " + w + " `" + h + "` of type " + ("`" + R + "` supplied to `" + v + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return I(o);
    }
    function k() {
      return I(d);
    }
    function C(r) {
      function o(L, b, v, w, h) {
        if (typeof r != "function")
          return new P("Property `" + h + "` of component `" + v + "` has invalid PropType notation inside arrayOf.");
        var g = L[b];
        if (!Array.isArray(g)) {
          var x = Z(g);
          return new P("Invalid " + w + " `" + h + "` of type " + ("`" + x + "` supplied to `" + v + "`, expected an array."));
        }
        for (var A = 0; A < g.length; A++) {
          var R = r(g, A, v, w, h + "[" + A + "]", c);
          if (R instanceof Error)
            return R;
        }
        return null;
      }
      return I(o);
    }
    function T() {
      function r(o, L, b, v, w) {
        var h = o[L];
        if (!p(h)) {
          var g = Z(h);
          return new P("Invalid " + v + " `" + w + "` of type " + ("`" + g + "` supplied to `" + b + "`, expected a single ReactElement."));
        }
        return null;
      }
      return I(r);
    }
    function n() {
      function r(o, L, b, v, w) {
        var h = o[L];
        if (!e.isValidElementType(h)) {
          var g = Z(h);
          return new P("Invalid " + v + " `" + w + "` of type " + ("`" + g + "` supplied to `" + b + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return I(r);
    }
    function F(r) {
      function o(L, b, v, w, h) {
        if (!(L[b] instanceof r)) {
          var g = r.name || m, x = ie(L[b]);
          return new P("Invalid " + w + " `" + h + "` of type " + ("`" + x + "` supplied to `" + v + "`, expected ") + ("instance of `" + g + "`."));
        }
        return null;
      }
      return I(o);
    }
    function G(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), d;
      function o(L, b, v, w, h) {
        for (var g = L[b], x = 0; x < r.length; x++)
          if ($(g, r[x]))
            return null;
        var A = JSON.stringify(r, function(D, t) {
          var Y = W(t);
          return Y === "symbol" ? String(t) : t;
        });
        return new P("Invalid " + w + " `" + h + "` of value `" + String(g) + "` " + ("supplied to `" + v + "`, expected one of " + A + "."));
      }
      return I(o);
    }
    function ee(r) {
      function o(L, b, v, w, h) {
        if (typeof r != "function")
          return new P("Property `" + h + "` of component `" + v + "` has invalid PropType notation inside objectOf.");
        var g = L[b], x = Z(g);
        if (x !== "object")
          return new P("Invalid " + w + " `" + h + "` of type " + ("`" + x + "` supplied to `" + v + "`, expected an object."));
        for (var A in g)
          if (i(g, A)) {
            var R = r(g, A, v, w, h + "." + A, c);
            if (R instanceof Error)
              return R;
          }
        return null;
      }
      return I(o);
    }
    function re(r) {
      if (!Array.isArray(r))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var o = 0; o < r.length; o++) {
        var L = r[o];
        if (typeof L != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + H(L) + " at index " + o + "."
          ), d;
      }
      function b(v, w, h, g, x) {
        for (var A = [], R = 0; R < r.length; R++) {
          var D = r[R], t = D(v, w, h, g, x, c);
          if (t == null)
            return null;
          t.data && i(t.data, "expectedType") && A.push(t.data.expectedType);
        }
        var Y = A.length > 0 ? ", expected one of type [" + A.join(", ") + "]" : "";
        return new P("Invalid " + g + " `" + x + "` supplied to " + ("`" + h + "`" + Y + "."));
      }
      return I(b);
    }
    function te() {
      function r(o, L, b, v, w) {
        return V(o[L]) ? null : new P("Invalid " + v + " `" + w + "` supplied to " + ("`" + b + "`, expected a ReactNode."));
      }
      return I(r);
    }
    function z(r, o, L, b, v) {
      return new P(
        (r || "React class") + ": " + o + " type `" + L + "." + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + v + "`."
      );
    }
    function ne(r) {
      function o(L, b, v, w, h) {
        var g = L[b], x = Z(g);
        if (x !== "object")
          return new P("Invalid " + w + " `" + h + "` of type `" + x + "` " + ("supplied to `" + v + "`, expected `object`."));
        for (var A in r) {
          var R = r[A];
          if (typeof R != "function")
            return z(v, w, h, A, W(R));
          var D = R(g, A, v, w, h + "." + A, c);
          if (D)
            return D;
        }
        return null;
      }
      return I(o);
    }
    function oe(r) {
      function o(L, b, v, w, h) {
        var g = L[b], x = Z(g);
        if (x !== "object")
          return new P("Invalid " + w + " `" + h + "` of type `" + x + "` " + ("supplied to `" + v + "`, expected `object`."));
        var A = a({}, L[b], r);
        for (var R in A) {
          var D = r[R];
          if (i(r, R) && typeof D != "function")
            return z(v, w, h, R, W(D));
          if (!D)
            return new P(
              "Invalid " + w + " `" + h + "` key `" + R + "` supplied to `" + v + "`.\nBad object: " + JSON.stringify(L[b], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var t = D(g, R, v, w, h + "." + R, c);
          if (t)
            return t;
        }
        return null;
      }
      return I(o);
    }
    function V(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(V);
          if (r === null || p(r))
            return !0;
          var o = u(r);
          if (o) {
            var L = o.call(r), b;
            if (o !== r.entries) {
              for (; !(b = L.next()).done; )
                if (!V(b.value))
                  return !1;
            } else
              for (; !(b = L.next()).done; ) {
                var v = b.value;
                if (v && !V(v[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ae(r, o) {
      return r === "symbol" ? !0 : o ? o["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && o instanceof Symbol : !1;
    }
    function Z(r) {
      var o = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : ae(o, r) ? "symbol" : o;
    }
    function W(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var o = Z(r);
      if (o === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return o;
    }
    function H(r) {
      var o = W(r);
      switch (o) {
        case "array":
        case "object":
          return "an " + o;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + o;
        default:
          return o;
      }
    }
    function ie(r) {
      return !r.constructor || !r.constructor.name ? m : r.constructor.name;
    }
    return E.checkPropTypes = f, E.resetWarningCache = f.resetWarningCache, E.PropTypes = E, E;
  }, ve;
}
var ye, _e;
function er() {
  if (_e) return ye;
  _e = 1;
  var e = /* @__PURE__ */ me();
  function a() {
  }
  function c() {
  }
  return c.resetWarningCache = a, ye = function() {
    function i(d, p, y, O, l, u) {
      if (u !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    i.isRequired = i;
    function f() {
      return i;
    }
    var s = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: f,
      element: i,
      elementType: i,
      instanceOf: f,
      node: i,
      objectOf: f,
      oneOf: f,
      oneOfType: f,
      shape: f,
      exact: f,
      checkPropTypes: c,
      resetWarningCache: a
    };
    return s.PropTypes = s, s;
  }, ye;
}
var Me;
function rr() {
  if (Me) return K.exports;
  if (Me = 1, process.env.NODE_ENV !== "production") {
    var e = $e(), a = !0;
    K.exports = /* @__PURE__ */ Ge()(e.isElement, a);
  } else
    K.exports = /* @__PURE__ */ er()();
  return K.exports;
}
var tr = /* @__PURE__ */ rr();
const S = /* @__PURE__ */ Ae(tr), q = S.oneOfType([S.string, S.number]), qe = {
  all: S.bool,
  grid: S.bool,
  aural: S.bool,
  braille: S.bool,
  handheld: S.bool,
  print: S.bool,
  projection: S.bool,
  screen: S.bool,
  tty: S.bool,
  tv: S.bool,
  embossed: S.bool
}, nr = {
  orientation: S.oneOf(["portrait", "landscape"]),
  scan: S.oneOf(["progressive", "interlace"]),
  aspectRatio: S.string,
  deviceAspectRatio: S.string,
  height: q,
  deviceHeight: q,
  width: q,
  deviceWidth: q,
  color: S.bool,
  colorIndex: S.bool,
  monochrome: S.bool,
  resolution: q,
  type: Object.keys(qe)
}, { type: wr, ...or } = nr, ar = {
  minAspectRatio: S.string,
  maxAspectRatio: S.string,
  minDeviceAspectRatio: S.string,
  maxDeviceAspectRatio: S.string,
  minHeight: q,
  maxHeight: q,
  minDeviceHeight: q,
  maxDeviceHeight: q,
  minWidth: q,
  maxWidth: q,
  minDeviceWidth: q,
  maxDeviceWidth: q,
  minColor: S.number,
  maxColor: S.number,
  minColorIndex: S.number,
  maxColorIndex: S.number,
  minMonochrome: S.number,
  maxMonochrome: S.number,
  minResolution: q,
  maxResolution: q,
  ...or
}, ir = { ...qe, ...ar };
var sr = {
  all: ir
};
const cr = (e) => `not ${e}`, ur = (e, a) => {
  const c = Ie(e);
  return typeof a == "number" && (a = `${a}px`), a === !0 ? c : a === !1 ? cr(c) : `(${c}: ${a})`;
}, fr = (e) => e.join(" and "), lr = (e) => {
  const a = [];
  return Object.keys(sr.all).forEach((c) => {
    const i = e[c];
    i != null && a.push(ur(c, i));
  }), fr(a);
}, dr = Ze(void 0), pr = (e) => e.query || lr(e), Pe = (e) => e ? Object.keys(e).reduce((c, i) => (c[Ie(i)] = e[i], c), {}) : void 0, De = () => {
  const e = Ye(!1);
  return U(() => {
    e.current = !0;
  }, []), e.current;
}, vr = (e) => {
  const a = ke(dr), c = () => Pe(e) || Pe(a), [i, f] = X(c);
  return U(() => {
    const s = c();
    Qe(i, s) || f(s);
  }, [e, a]), i;
}, yr = (e) => {
  const a = () => pr(e), [c, i] = X(a);
  return U(() => {
    const f = a();
    c !== f && i(f);
  }, [e]), c;
}, mr = (e, a) => {
  const c = () => Ve(e, a || {}, !!a), [i, f] = X(c), s = De();
  return U(() => {
    if (s) {
      const d = c();
      return f(d), () => {
        d && d.dispose();
      };
    }
  }, [e, a]), i;
}, hr = (e) => {
  const [a, c] = X(e.matches);
  return U(() => {
    const i = (f) => {
      c(f.matches);
    };
    return e.addListener(i), c(e.matches), () => {
      e.removeListener(i);
    };
  }, [e]), a;
}, br = (e, a, c) => {
  const i = vr(a), f = yr(e);
  if (!f)
    throw new Error("Invalid or missing MediaQuery!");
  const s = mr(f, i), d = hr(s);
  return De(), U(() => {
  }, [d]), U(() => () => {
    s && s.dispose();
  }, []), d;
}, gr = "data:image/svg+xml,%3csvg%20width='80'%20height='45'%20viewBox='0%200%2080%2045'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='shadow'%20d='M78.64%2021.21L43.65%201L18.65%201.9L1%2012.09L47.77%2039.03L78.64%2021.21Z'%20fill='%23099FC3'/%3e%3cpath%20d='M78.64%2026.32L47.77%2044.15L1%2016.85V12.09L47.77%2039.03L78.64%2021.21V26.32Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M43.632%200.500324C43.7259%200.496945%2043.8188%200.520064%2043.9001%200.567033L78.8901%2020.777C79.0447%2020.8664%2079.14%2021.0314%2079.14%2021.21V26.32C79.14%2026.4986%2079.0447%2026.6636%2078.8901%2026.753L48.0201%2044.583C47.8646%2044.6728%2047.673%2044.6723%2047.5179%2044.5818L0.747944%2017.2818C0.594403%2017.1922%200.5%2017.0278%200.5%2016.85V12.09C0.5%2011.9114%200.595301%2011.7463%200.750004%2011.657L18.4%201.46698C18.4707%201.42615%2018.5504%201.40326%2018.632%201.40032L43.632%200.500324ZM18.7923%202.3952L2.00088%2012.0895L47.7697%2038.4528L77.6401%2021.2099L43.5244%201.50485L18.7923%202.3952ZM78.14%2022.076L48.27%2039.3187V43.2838L78.14%2026.0314V22.076ZM47.27%2043.2792V39.319L1.5%2012.955V16.5629L47.27%2043.2792Z'%20fill='%2300040F'/%3e%3cpath%20d='M40.0799%209.90712C40.2347%209.81775%2040.4253%209.81774%2040.5801%209.90711L62.5701%2022.6071C62.7248%2022.6964%2062.82%2022.8615%2062.82%2023.0401C62.82%2023.2187%2062.7247%2023.3838%2062.57%2023.4731L48.04%2031.8631C47.8855%2031.9523%2047.6951%2031.9524%2047.5405%2031.8634L25.5205%2019.1834C25.3656%2019.0942%2025.2701%2018.9291%2025.27%2018.7504C25.2699%2018.5717%2025.3652%2018.4065%2025.5199%2018.3171L40.0799%209.90712Z'%20fill='%23DAFE76'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M40.0799%209.90712C40.2347%209.81775%2040.4253%209.81774%2040.5801%209.90711L62.5701%2022.6071C62.7248%2022.6964%2062.82%2022.8615%2062.82%2023.0401C62.82%2023.2187%2062.7247%2023.3838%2062.57%2023.4731L48.04%2031.8631C47.8855%2031.9523%2047.6951%2031.9524%2047.5405%2031.8634L25.5205%2019.1834C25.3656%2019.0942%2025.2701%2018.9291%2025.27%2018.7504C25.2699%2018.5717%2025.3652%2018.4065%2025.5199%2018.3171L40.0799%209.90712ZM39.9912%2011.1132L27.5717%2018.2868L36.4009%2018.4673L41.0416%2015.7907L39.9912%2011.1132ZM41.6099%2016.6173L37.5308%2018.97L46.8998%2024.3728L50.9703%2022.0203L41.6099%2016.6173ZM52.081%2022.5334L47.4411%2025.2149L48.1842%2030.6251L60.7226%2023.3851L52.081%2022.5334ZM60.0656%2022.3155L52.1265%2021.5331L42.0498%2015.7166L41.0678%2011.3436L60.0656%2022.3155ZM47.1559%2030.488L46.438%2025.2608L36.3914%2019.4674L27.7093%2019.2898L47.1559%2030.488Z'%20fill='%2300040F'/%3e%3c/svg%3e", Lr = "data:image/svg+xml,%3csvg%20width='48'%20height='28'%20viewBox='0%200%2048%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20id='shadow'%20d='M47.1841%2013.126L26.1901%201L11.1901%201.54L0.600098%207.654L28.6621%2023.818L47.1841%2013.126Z'%20fill='%23099FC3'/%3e%3cpath%20d='M47.1841%2016.1919L28.6621%2026.8899L0.600098%2010.5099V7.65393L28.6621%2023.8179L47.1841%2013.1259V16.1919Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M26.1765%200.625243C26.2469%200.622709%2026.3165%200.640048%2026.3775%200.675275L47.3715%2012.8013C47.4875%2012.8683%2047.559%2012.992%2047.559%2013.126V16.192C47.559%2016.326%2047.4875%2016.4497%2047.3715%2016.5167L28.8495%2027.2147C28.7329%2027.2821%2028.5892%2027.2817%2028.4729%2027.2139L0.410934%2010.8339C0.295778%2010.7666%200.224976%2010.6433%200.224976%2010.51L0.224976%207.654C0.224976%207.52002%200.296452%207.39623%200.412479%207.32924L11.0025%201.21524C11.0555%201.18461%2011.1153%201.16745%2011.1765%201.16524L26.1765%200.625243ZM11.2967%201.9114L1.35064%207.65363L28.6618%2023.3851L46.434%2013.1259L26.0958%201.37863L11.2967%201.9114ZM46.809%2013.7755L29.037%2024.0345V26.2404L46.809%2015.9755V13.7755ZM28.287%2026.2369V24.0348L0.974976%208.30277V10.2947L28.287%2026.2369Z'%20fill='%2300040F'/%3e%3cpath%20d='M24.0479%206.34418C24.1408%206.29055%2024.2552%206.29055%2024.348%206.34417L37.542%2013.9642C37.6348%2014.0178%2037.692%2014.1168%2037.692%2014.224C37.692%2014.3311%2037.6348%2014.4302%2037.542%2014.4838L28.824%2019.5178C28.7313%2019.5713%2028.6171%2019.5714%2028.5243%2019.5179L15.3123%2011.9099C15.2194%2011.8564%2015.1621%2011.7574%2015.162%2011.6502C15.1619%2011.5429%2015.2191%2011.4438%2015.3119%2011.3902L24.0479%206.34418Z'%20fill='%23DAFE76'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M24.0105%206.27928C24.1265%206.21225%2024.2695%206.21224%2024.3856%206.27927L37.5796%2013.8993C37.6956%2013.9663%2037.767%2014.0901%2037.767%2014.224C37.767%2014.358%2037.6956%2014.4818%2037.5796%2014.5488L28.8616%2019.5828C28.7457%2019.6497%2028.6029%2019.6498%2028.4869%2019.583L15.2749%2011.975C15.1587%2011.9081%2015.0871%2011.7843%2015.087%2011.6503C15.0869%2011.5162%2015.1584%2011.3923%2015.2745%2011.3253L24.0105%206.27928ZM23.9439%207.18385L16.8133%2011.3026L21.8212%2011.4049L24.5397%209.837L23.9439%207.18385ZM24.966%2010.457L22.6687%2011.782L28.1398%2014.937L30.4322%2013.6122L24.966%2010.457ZM31.2653%2013.997L28.5458%2015.5686L28.9696%2018.6543L36.194%2014.4828L31.2653%2013.997ZM35.7012%2013.6806L31.2994%2013.2468L25.2959%209.78142L24.7514%207.35663L35.7012%2013.6806ZM28.1985%2018.5514L27.7935%2015.6031L21.8141%2012.155L16.9165%2012.0548L28.1985%2018.5514Z'%20fill='%2300040F'/%3e%3c/svg%3e", Er = "data:image/svg+xml,%3csvg%20width='79'%20height='41'%20viewBox='0%200%2079%2041'%20fill='%2300040F'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M77.7519%2020.1999L43.6406%200.203527C43.3991%200.0649594%2043.1156%20-0.0096545%2042.8321%200.00100455L17.393%200.928343C17.1515%200.928343%2016.91%201.00295%2016.7%201.13086L0.751999%2010.4789C-0.255909%2011.0651%20-0.24541%2012.536%200.751999%2013.1223L46.8428%2040.079C47.3047%2040.3562%2047.8822%2040.3455%2048.3441%2040.079L77.7519%2022.8433C78.7494%2022.2571%2078.7494%2020.7862%2077.7519%2020.1999Z'/%3e%3c/svg%3e", N = "dds-loader-v0112";
function xr({ children: e, className: a = "", ...c }) {
  const i = br({
    query: "(min-width: 560px)"
  });
  return /* @__PURE__ */ be("div", { className: `${N} ${a}`, ...c, children: [
    /* @__PURE__ */ be("div", { className: `${N}-loader`, children: [
      /* @__PURE__ */ se(
        "img",
        {
          className: `${N}-sim`,
          src: i ? gr : Lr,
          alt: ""
        }
      ),
      /* @__PURE__ */ se("img", { className: `${N}-shadow`, src: Er, alt: "" })
    ] }),
    /* @__PURE__ */ se("div", { className: `${N}-text`, children: e ?? "Loading..." })
  ] });
}
export {
  xr as Loader
};
//# sourceMappingURL=index.js.map
